import React from 'react';
import LoadingWrapper from '../../../hocs/LoadingWrapper';
import ResultsItem from './ResultsItem';

const Results = ({ results, query, fetching, onClickResult }) => (
    <div className="ckp-events-search-results">
        {results.length && !fetching ? <h2 className="ckp-events-search-title ckp-ts-h4">Results</h2> : null}
        <div className="ckp-events-search-results-scroll">
            <LoadingWrapper className="ckp-events-search-loading" label="Searching..." color="white" show={fetching}>
                <ul className="ckp-events-search-items">
                    {results.map(res => <ResultsItem onClick={onClickResult} key={res.id} query={query} entry={res} />)}
                </ul>
            </LoadingWrapper>
        </div>
    </div>
);

export default Results;



// WEBPACK FOOTER //
// ./src/components/application/timetable/search/Results.js